import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/network/$")({
    component: RouteComponent,
    beforeLoad: ({ location, search }) => {
        throw redirect({
            to: `/ntimev1/$`,
            params: {
                _splat: location.pathname,
            },
            search,
        });
    },
});

function RouteComponent() {
    return "Hello /dashboard/network/!";
}
